import { Drawer, IconButton, styled, Typography } from '@mui/material'
import { WapprunnerCreate } from 'weblite-web-wapprunner'
import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { useIsDesktopSize } from '$common/react-hooks/layout'
import { CloseIcon } from '$common/icons'

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
`

const Header = styled('div')`
  width: 100%;
  height: 50px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  background-color: #7f7f7f;
  padding-right: 15px;
`

interface PropTypes {
  isOpen: boolean
  title: string
  wapp: {
    wappId: string
    wisId: string
    input: any
  }
  parent?: any
  hasHeader?: boolean
}

export function WappDrawerModal({
  isOpen,
  title,
  wapp,
  parent,
  hasHeader,
}: PropTypes) {
  const { wappId, wisId, input } = wapp
  const isDesktop = useIsDesktopSize()

  return (
    <Drawer
      open={isOpen}
      onClose={closeCurrentModal}
      anchor="bottom"
      PaperProps={{
        sx: {
          right: isDesktop ? 'unset' : 0,
          height: '100%',
          width: isDesktop ? '360px' : '100%',
        },
      }}
    >
      <Container>
        {hasHeader && (
          <Header>
            <Typography variant="titleBold" color="white">
              {title}
            </Typography>

            <IconButton onClick={closeCurrentModal}>
              <CloseIcon />
            </IconButton>
          </Header>
        )}

        <WapprunnerCreate
          key={`${wappId}${wisId}`}
          // @ts-ignore
          mode="drawer"
          wappId={wappId}
          wisId={wisId}
          input={input}
          parent={parent}
        />
      </Container>
    </Drawer>
  )
}
